import React, { useEffect } from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import gdanskSaleFormConfigs, {
  GDANSK_BASIN_KIND_INPUT,
  GDANSK_DATE_INPUT,
  GDANSK_DATES_INFO,
  GDANSK_ENTRIES_QNT_INPUT,
  GDANSK_INSTRUCTOR_CHECKBOX_INPUT,
  GDANSK_INSTRUCTOR_LANE_INPUT,
  GDANSK_LANE_SELECT_INPUT,
  GDANSK_TIME_OF_DAY_INPUT,
  GdanskSaleFormFieldConfig,
  GdanskSaleFormType,
} from "./gdanskSaleStep2FormConfig";
import GdanskDateInput from "../FormInputs/GdanskDateInput";
import EADivider from "../../shared/EADivider";
import GdanskInstructorCheckboxInput from "../FormInputs/GdanskIntructorCheckboxInput";
import GdanskLaneSelectInput from "../FormInputs/GdanskLaneSelectInput";
import GdanskColorInput from "../FormInputs/GdanskColorInput";
import GdanskBookingGroupInput from "../FormInputs/GdanskBookingGroupInput";
import GdanskMaterialGroupInput from "../FormInputs/GdanskMaterialGroupInput";
import GdanskDatesInfo from "../FormInputs/GdanskDatesInfo";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
  setIsFormValid: (value: boolean) => void;
}

const GdanskSaleStep2Form: React.FC<IProps> = ({ form, setForm, setIsFormValid }) => {
  const formConfig = gdanskSaleFormConfigs[form.kind as GdanskSaleFormType];

  useEffect(() => {
    const isValid = formConfig.validate(form);
    setIsFormValid(isValid);
    //eslint-disable-next-line
  }, [form, formConfig]);

  const getFieldByType = (type: GdanskSaleFormFieldConfig) => {
    const formProps = { form, setForm };
    switch (type) {
      case GDANSK_DATE_INPUT:
        return <GdanskDateInput {...formProps} />;
      case GDANSK_ENTRIES_QNT_INPUT:
        return <GdanskBookingGroupInput {...formProps} />;
      case GDANSK_BASIN_KIND_INPUT:
        return <GdanskColorInput {...formProps} />;
      case GDANSK_TIME_OF_DAY_INPUT:
        return <GdanskMaterialGroupInput {...formProps} />;
      case GDANSK_INSTRUCTOR_CHECKBOX_INPUT:
        return <GdanskInstructorCheckboxInput {...formProps} />;
      case GDANSK_LANE_SELECT_INPUT:
        return <GdanskLaneSelectInput {...formProps} />;
      case GDANSK_INSTRUCTOR_LANE_INPUT:
        return <GdanskLaneSelectInput {...formProps} isInstructor />;
      case GDANSK_DATES_INFO:
        return <GdanskDatesInfo {...formProps} />;
      default:
        return "";
    }
  };

  return (
    <div className="gdansk-form-container">
      {formConfig.fields.map((field) => (
        <div key={field} className="gdansk-form-input-wrapper">
          <EADivider />
          {getFieldByType(field)}
        </div>
      ))}
    </div>
  );
};

export default GdanskSaleStep2Form;
